/**
 * Tutorial guidato della pagina Layout.
 *
 * Nessun preparativo: la pagina e' una colonna di riquadri tutti aperti, e il giro
 * la percorre dall'alto in basso. I passi che parlano di una famiglia di riquadri
 * uguali - le versioni per area del tema - si agganciano al primo e
 * lo dicono nel testo, invece di ripetere cinque volte la stessa cosa.
 */
const SCOPE = '[data-tour-scope="layout"]';

const at = name => `${SCOPE} [data-tour="${name}"]`;

export function createLayoutTourSteps() {
	return [
		{
			body: "Da qui si governa l'aspetto del sito pubblico: logo e colori, cosa c'e' in home e in che ordine, quale versione di header e footer usare, cosa scrivere nelle pagine prodotto. E' una colonna di riquadri, uno per argomento: la fila di etichette in alto, che resta in vista mentre scorri, porta direttamente a ognuno.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'L’aspetto del sito',
		},
		{
			body: "C'e' un solo pulsante, Salva modifiche, nella barra in fondo, e salva l'intera pagina: puoi toccare piu' riquadri e salvare una volta sola alla fine. Accanto, la barra dice se ci sono modifiche non ancora salvate.",
			key: 'save',
			placement: 'right',
			target: at('save'),
			title: 'Un solo Salva per tutto',
		},
		{
			body: "Il logo del sito: trascinalo nel riquadro accanto o cliccalo per sceglierlo, SVG, JPG, GIF o PNG. L'SVG e' quello giusto per un logo, resta nitido a qualsiasi dimensione. La X sull'anteprima toglie il logo caricato.",
			key: 'logo',
			placement: 'top',
			target: at('logo'),
			title: 'Il logo',
		},
		{
			body: "I quattro colori del tema: un clic sul campione apre il selettore. Primario e' il colore dominante - pulsanti, link, intestazioni - Secondario l'accompagnamento, Terzo e Accento servono ai dettagli. Cambiarli qui li cambia su tutto il sito: non c'e' un posto dove correggere la singola pagina.",
			key: 'colors',
			placement: 'top',
			target: at('colors'),
			title: 'I colori',
		},
		{
			body: "Le immagini che scorrono in cima alla home. L'ordine si cambia trascinando dalla crocetta, la spunta le mette a tutto schermo, e titolo, contenuto e indirizzo si scrivono lingua per lingua - la bandiera accanto al campo dice quale. In fondo al riquadro si carica una nuova immagine oppure si cerca un prodotto, per mandare la slide dritta alla sua scheda.",
			key: 'slider',
			placement: 'top',
			target: at('slider'),
			title: 'Le slide della home',
		},
		{
			body: "Di cosa e' fatta la home e in che ordine: ogni riga e' una fascia - le novita', le categorie in evidenza, i piu' venduti - si accende con la spunta e si sposta trascinando dalla crocetta. Spenta non sparisce da qui, sparisce dal sito.",
			key: 'home',
			placement: 'top',
			target: at('home'),
			title: 'Le fasce della home',
		},
		{
			body: 'Interruttori che accendono intere funzioni del sito. Manutenzione chiude il sito ai visitatori: da accendere solo sapendo cosa si sta facendo. Prodotti fine carrello attende la vetrina che si riempie nella pagina Fine carrello, e Notifica quando torna disponibile fa comparire il modulo di avviso sui prodotti esauriti, Confronta prodotti aggiunge la casella Confronta nelle categorie di ultimo livello.',
			key: 'options',
			placement: 'top',
			target: at('options'),
			title: 'Le funzioni del sito',
		},
		{
			body: "Il tema decide in un colpo l'aspetto di header, footer, home, pagine categoria e card prodotto. Colori, fasce della home e funzioni restano quelli scelti negli altri riquadri. I temi segnati «In arrivo» si potranno scegliere appena pronti.",
			key: 'theme',
			placement: 'top',
			target: at('theme'),
			title: 'Il tema del sito',
		},
		{
			body: "Il messaggio della striscia in cima all'header - offerte, spedizione gratuita, avvisi - si scrive per ogni lingua, con Copia e Traduci per le lingue dopo la prima.",
			key: 'header',
			placement: 'top',
			target: at('header'),
			title: 'Il messaggio sopra l’header',
		},
		{
			body: "In Avanzate si cambia la versione di una sola area - per esempio l'header di un altro tema - lasciando il resto com'e'. Il tema scelto mostra allora «Personalizzato»; cliccarlo di nuovo riporta tutte le aree alla sua versione. Nessuna di queste scelte tocca i contenuti, solo la forma con cui vengono mostrati.",
			key: 'variants',
			placement: 'top',
			target: at('variants'),
			title: 'Versione per singola area',
		},
		{
			body: 'Come si presentano le varianti nella scheda prodotto - a pallini, a elenco, a menu - e, sotto, la nota che compare in tutte le pagine prodotto: quella dei tempi di consegna o delle condizioni di reso, scritta lingua per lingua.',
			key: 'product',
			placement: 'top',
			target: at('product'),
			title: 'La scheda prodotto',
		},
		{
			body: "Quello che il sito dice di se' ai motori di ricerca e ai social: titolo, descrizione, favicon e l'immagine che compare quando qualcuno incolla un link del sito in chat. Per favicon e og_image il pulsante Aggiungi nuovo apre il caricamento del file.",
			key: 'seo',
			placement: 'top',
			target: at('seo'),
			title: 'SEO e anteprime',
		},
		{
			body: "Gli indirizzi dei profili social, che il sito usa per le icone nel footer. Un campo vuoto vuol dire icona che non compare: non c'e' da spegnere niente.",
			key: 'social',
			placement: 'top',
			target: at('social'),
			title: 'I link social',
		},
		{
			body: "Codice che il sito esegue davvero: Header e Footer vengono iniettati in tutte le pagine - e' il posto di Google Tag Manager, del pixel di Meta, delle chat - mentre gli altri partono su un fatto preciso, come l'aggiunta al carrello o l'acquisto, e hanno a disposizione le variabili elencate sopra ogni campo. Uno script sbagliato qui si vede su tutto il sito: conviene incollare solo codice di cui ci si fida.",
			key: 'script',
			placement: 'top',
			target: at('script'),
			title: 'Gli script di terze parti',
		},
	];
}
